import { render, staticRenderFns } from "./NotificationTemplateUpdate.vue?vue&type=template&id=a755931e&"
import script from "./NotificationTemplateUpdate.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports